import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import Pagination from "react-js-pagination";
import { itemCount, classNames } from "Constants";
import NoContent, { NO_SESSIONSCANED } from "NoContent";
import LocaleStrings from "Languages";
import BadgeForUsersListItem from "./badge-for-users-list-item";
import Loader from "Loader";

const GenerateBadgeUsersTable = (props) => {
  let {
    userList,
    pageNumber,
    badgeFor,
    allCheck,
    checkAndUncheckAllUsers,
    pagination,
    printSingleBadge,
  } = props;

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    return () => {};
  }, []);

  const paginationCallback = useCallback(
    (newPageNumber) => {
      pagination(newPageNumber);
    },
    [] // Tells React to memoize regardless of arguments.
  );

  const generateSingleBadge = (item) => {
    // console.log("item 1", item);
    printSingleBadge(item);
  };

  /* Render table list here */
  const renderUserTablelist = () => {
    let pageDataLength = userList
      ? userList.data
        ? userList.data.length
        : ""
      : "";

    return _.map(userList.data, (appUser, index) => {
      return (
        <BadgeForUsersListItem
          key={index}
          badgeFor={props.badgeFor}
          appUser={appUser}
          selectedUsers={props.selectedUsers}
          checkAndUncheckUsers={props.checkAndUncheckUsers}
          generateSingleBadge={generateSingleBadge}
        />
      );
    });
  };

  return (
    <div>
      {userList && userList.data ? (
        <div
          className={classNames(
            userList.data.length > 0 ? "" : "custom-align-center",
            "badge-generate-canvas-container"
          )}
        >
          {userList && userList.data && userList.data.length > 0 ? (
            <div>
              <table className="table">
                <thead className="analyticsTable-">
                  <tr>
                    <th style={{ textAlign: "left" }}>
                      {badgeFor === "choose_attendees" ? (
                        <label className="custom-container-checkbox">
                          <input
                            type="checkbox"
                            onChange={checkAndUncheckAllUsers}
                            checked={allCheck}
                          />
                          <span className="checkmark" />
                        </label>
                      ) : (
                        ""
                      )}
                    </th>
                    <th style={{ textAlign: "left" }}>
                      {
                        LocaleStrings.dashboard_badgedesign_generate_badge_table_th_name
                      }
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody className="tbody-background-">
                  {renderUserTablelist()}
                </tbody>
              </table>

              {/* Pagination */}
              {userList && userList.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={props.userList.count}
                  pageRangeDisplayed={10}
                  onChange={paginationCallback}
                  style={{ float: "right" }}
                />
              ) : null}
            </div>
          ) : (
            <NoContent contentType={NO_SESSIONSCANED} />
          )}
        </div>
      ) : (
        <div className="badge-generate-canvas-container custom-align-center">
          <div className="loader-container">
            <Loader />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    userList: state.dashboardBadgeUserList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateBadgeUsersTable);
